import { render, staticRenderFns } from "./Prevention.vue?vue&type=template&id=7692a7e8&scoped=true&"
import script from "./Prevention.vue?vue&type=script&lang=js&"
export * from "./Prevention.vue?vue&type=script&lang=js&"
import style0 from "./Prevention.vue?vue&type=style&index=0&id=7692a7e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7692a7e8",
  null
  
)

export default component.exports